import { VCol } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCol,{staticClass:"tm-col"},[_c('div',{staticClass:"tm-box-frame"},[_c('tm-list-frame')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }